import React from 'react'
import VisibilitySensor from '../VisibilitySensor'
import { makeStyles } from '@material-ui/core/styles'
import PhotoModal from './PhotoModal'
import Content from './Content'
import BoxDecoration from '../Decorations/Box'
import { DecorazioniPageConfig } from '../../configuration'
import AssignId from '../AssignId'

const styles = theme => ({
    root: {
        padding: '120px 10rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1400)]: {
            padding: '50px 5rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1300)]: {
            padding: '50px 3rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1100)]: {
            padding: '50px 1rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 850)]: {
            padding: '60px 1rem',
            flexDirection: 'column'
        }
    }
})

const useStyles = makeStyles(styles)

export default function Decorazioni() {
    const classes = useStyles()
    return (
        <div style={{ position: 'relative' }} >
            <AssignId
                absolute
                y='0'
                yMobile='0'
                id={DecorazioniPageConfig.slug}
            />
            <BoxDecoration hideMobile right='0' left='-40%' top='100%' bottom={0} rotate='22.5deg' scale='1.5' z={0} />
            <BoxDecoration hideMobile right='0' left='-40%' top='100%' bottom={0} rotate='45deg' scale='1.5' z={0} />
            <BoxDecoration hideMobile right='0' left='-40%' top='100%' bottom={0} rotate='67.5deg' scale='1.5' z={0} />
            <BoxDecoration hideMobile right='0' left='-40%' top='100%' bottom={0} rotate='0deg' scale='1.5' z={0} />
            <div className={classes.root} >
                <PhotoModal img={DecorazioniPageConfig.image} zoomedImg={DecorazioniPageConfig.zoomedImage} />
                <VisibilitySensor index={5} />
                <Content
                    primaryText={DecorazioniPageConfig.content.primary}
                    secondaryText={DecorazioniPageConfig.content.secondary}
                />
            </div>
        </div>
    )
}
